export default __webpack_public_path__ + "static/media/block-button.b89400db.jpg";